import styled from 'styled-components'

const DivDetailsTrack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .card-track {
    height: 200px;
  }
`

export { DivDetailsTrack }
